"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Location = function Location(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", {
      d: "M7.54 11.747c-.25-.46-.483-.905-.699-1.333C5.926 8.596 5.4 7.18 5.4 6.493A3.596 3.596 0 0 1 9 2.9c1.989 0 3.6 1.609 3.6 3.593h1.8A5.396 5.396 0 0 0 9 1.1a5.396 5.396 0 0 0-5.4 5.393c0 1.07.59 2.656 1.633 4.73.225.447.468.91.727 1.384a69.618 69.618 0 0 0 2.282 3.878L9 17.67l.758-1.184a68.905 68.905 0 0 0 .715-1.156 69.618 69.618 0 0 0 1.567-2.722c.26-.475.502-.937.727-1.384C13.81 9.15 14.4 7.563 14.4 6.493h-1.8c0 .687-.526 2.103-1.441 3.921-.216.428-.45.874-.7 1.333A67.444 67.444 0 0 1 9 14.287a67.444 67.444 0 0 1-1.46-2.54z",
      fillRule: "nonzero",
      fill: "#000"
    })
  );
};

exports.default = Location;
Location.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Location"
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Location.js
// module id = 626
// module chunks = 0